import React from "react";

const initialState = {
    pushManager: false,
    serviceWorker: false,
}

export const FeatureContext = React.createContext(initialState);